import React, {useState} from "react";
import HomeSideNavBar from "./HomeSideNavBar";
import Header from "./Header";
import ApiDataProvider from "./ApiDataContext";
import {Contact, Bell, FileUp, MessageCircle, Tags} from "lucide-react";
import CustomerList from "./Customer/CustomerList";
import CustomerDetailsUpload from "./Customer/CustomerDetailsUpload";
import MappingComponent from "./Customer/MappingComponent";
import NotificationPreferences from "./Settings/NotificationPreferences";
import WhatsAppRecipients from "./Settings/WhatsAppRecipients";
import {hasPermission} from "../utils/rolePermissions";
import PageHeader from "../components/layout/PageHeader";
import Tabs from "../components/ui/Tabs";

const UPLOAD_CUSTOMER = "UploadCustomer";
const CUSTOMER_LIST = "CustomerList";
const MAPPING = "mapping";
const NOTIFICATION_PREFS = "NotificationPreferences";
const WHATSAPP_RECIPIENTS = "WhatsAppRecipients";

const TAB_META = {
  [CUSTOMER_LIST]:        {label: "Customer List",     subtitle: "Browse and manage your existing customer records."},
  [UPLOAD_CUSTOMER]:      {label: "Upload",            subtitle: "Bulk-import customers from an Excel sheet."},
  [MAPPING]:              {label: "Mapping",           subtitle: "Associate customer tags and groupings."},
  [NOTIFICATION_PREFS]:   {label: "Notifications",     subtitle: "Configure how and when alerts are delivered."},
  [WHATSAPP_RECIPIENTS]:  {label: "WhatsApp Recipients", subtitle: "Manage additional numbers for GT06 tracker alerts."},
};

function Settings() {
  const canViewCustomers = hasPermission("settings_customerList");
  const canUpload = hasPermission("settings_uploadCustomer");
  const canMapping = hasPermission("settings_mapping");

  const getDefaultTab = () => canViewCustomers ? CUSTOMER_LIST : NOTIFICATION_PREFS;
  const [selectedComponent, setSelectedComponent] = useState(getDefaultTab());
  const activeMeta = TAB_META[selectedComponent] || {label: "Settings", subtitle: "Configure your account."};

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case UPLOAD_CUSTOMER:    return canUpload ? <CustomerDetailsUpload /> : null;
      case CUSTOMER_LIST:      return canViewCustomers ? <CustomerList /> : null;
      case MAPPING:            return canMapping ? <MappingComponent /> : null;
      case NOTIFICATION_PREFS: return <NotificationPreferences />;
      case WHATSAPP_RECIPIENTS: return <WhatsAppRecipients />;
      default:                 return null;
    }
  };

  const tabItems = [
    canViewCustomers && {value: CUSTOMER_LIST,   label: "Customers",     icon: Contact},
    canUpload &&        {value: UPLOAD_CUSTOMER, label: "Upload",        icon: FileUp},
    canMapping &&       {value: MAPPING,         label: "Mapping",       icon: Tags},
                        {value: NOTIFICATION_PREFS, label: "Notifications", icon: Bell},
                        {value: WHATSAPP_RECIPIENTS, label: "WhatsApp Recipients", icon: MessageCircle},
  ].filter(Boolean);

  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <PageHeader
              title="Settings"
              subtitle={activeMeta.subtitle}
              breadcrumbs={[{label: "Settings"}, {label: activeMeta.label}]}
            />
            <Tabs value={selectedComponent} onChange={setSelectedComponent} items={tabItems} className="bg-white" />
            <div className="flex-1 min-h-0 px-2 sm:px-4 lg:px-6 py-4">
              {renderSelectedComponent()}
            </div>
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Settings;
